import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";

import PageWrapper from "../components/PageWrapper";
import { Section, Title, Text } from "../components/Core";
import CTA from "../sections/nightshift/CTA";
import BlogList from "../sections/blog/BlogList";

const BlogRegular = () => {
  return (
    <>
      <Helmet>
        <title>NightShift | Blog</title>
      </Helmet>
      <PageWrapper>
        <Section className="pb-0">
          <div className="pt-5"></div>
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg="8">
                <Title variant="hero">NightShift Blog</Title>
              </Col>
            </Row>
          </Container>
        </Section>
        <BlogList />
        <CTA />
      </PageWrapper>
    </>
  );
};
export default BlogRegular;
